import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import './styles/main.scss';
import './styles/_variables.scss';
import { store, persistor } from './store/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import PrivateRoute from './components/Security/PrivateRoute/index.jsx';

import Login from './pages/Login/index.jsx';
import Home from './pages/Home/index.jsx';
import Layout from './components/Global/Layout';
import Profile from './pages/Profile/index.jsx';
import RegisterColaborator from './pages/Registers/RegisterColaborator/index.jsx';
import LimpezaPage from './pages/Views/LimpezaPage/index.jsx';
import ExpedientePage from './pages/Views/ExpedientePage/index.jsx';
import DiversosPage from './pages/Views/DiversosPage/index.jsx';
import VendedoresPage from './pages/Views/VendedoresPage/index.jsx';
import PedidoPage from './pages/Views/OrcamentosLojaPage/index.jsx';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import * as serviceWorker from '../src/serviceWorker.js';
import ColaboratorsPage from './pages/Views/ColaboratorsPage/index.jsx';
import EditColaborator from './pages/Edit/EditColaborator/index.jsx';
import RegisterProduct from './pages/Registers/RegisterProduct/index.jsx';
import OrcamentosPage from './pages/Views/OrcamentosPage/index.jsx';
import RegisterOrcamento from './pages/Registers/RegisterOrcamento/index.jsx';
import EditProduct from './pages/Edit/EditProduct/index.jsx';
import RegisterVendedor from './pages/Registers/RegisterVendedor/index.jsx';
import ClientesPage from './pages/Views/ClientesPage/index.jsx';
import RegisterCliente from './pages/Registers/RegisterCliente/index.jsx';
import SegmentosPage from './pages/Views/SegmentosPage/index.jsx';
import CategoriaProdutosPage from './pages/Views/CategoriaProdutosPage/index.jsx';
import RelatoriosPage from './pages/Views/RelatoriosPage/index.jsx';
serviceWorker.unregister();

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Incluindo o componente Template como o layout geral */}
          <Route element={<Layout />}>
            {/* Páginas de Acesso */}
            <Route
              path="/dashboard"
              element={<PrivateRoute element={<Home />} />}
            />
            <Route
              path="/perfil"
              element={<PrivateRoute element={<Profile />} />}
            />
            <Route
              path="/colaboradores"
              element={<PrivateRoute element={<ColaboratorsPage />} />}
            />
            <Route
              path="/vendedores"
              element={<PrivateRoute element={<VendedoresPage />} />}
            />
            <Route
              path="/clientes"
              element={<PrivateRoute element={<ClientesPage />} />}
            />
            <Route
              path="/limpeza"
              element={<PrivateRoute element={<LimpezaPage />} />}
            />
            <Route
              path="/expediente"
              element={<PrivateRoute element={<ExpedientePage />} />}
            />
            <Route
              path="/diversos"
              element={<PrivateRoute element={<DiversosPage />} />}
            />
            <Route
              path="/segmentos"
              element={<PrivateRoute element={<SegmentosPage />} />}
            />
            <Route
              path="/categorias/:id"
              element={<PrivateRoute element={<CategoriaProdutosPage />} />}
            />
            <Route
              path="/orcamentos"
              element={<PrivateRoute element={<OrcamentosPage />} />}
            />
            <Route
              path="/orcamentos-loja"
              element={<PrivateRoute element={<PedidoPage />} />}
            />
            <Route
              path="/relatorios"
              element={<PrivateRoute element={<RelatoriosPage />} />}
            />

            {/* Páginas de Cadastro */}
            <Route
              path="/cadastro/colaborador"
              element={<PrivateRoute element={<RegisterColaborator />} />}
            />
            <Route
              path="/cadastro/vendedor/:id?"
              element={<PrivateRoute element={<RegisterVendedor />} />}
            />
            <Route
              path="/cadastro/cliente/:id?"
              element={<PrivateRoute element={<RegisterCliente />} />}
            />
            <Route
              path="/cadastro/produto/:tipo?"
              element={<PrivateRoute element={<RegisterProduct />} />}
            />
            <Route
              path="/gerar-orcamento"
              element={<PrivateRoute element={<RegisterOrcamento />} />}
            />

            {/* Páginas de Edição de Cadastro */}
            <Route
              path="/editar/colaborador/:id"
              element={<PrivateRoute element={<EditColaborator />} />}
            />
            <Route
              path="/editar/produto/:id"
              element={<PrivateRoute element={<EditProduct />} />}
            />
          </Route>
          {/* Redirecionar qualquer outra rota que não exista para a página de dashboard */}
          <Route path="/*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </PersistGate>
  </Provider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastContainer autoClose={2000} />
    <App />
  </React.StrictMode>
);

reportWebVitals();
